import { render, staticRenderFns } from "./PopoverRecebimentoPendente.vue?vue&type=template&id=3eceda80"
import script from "./PopoverRecebimentoPendente.vue?vue&type=script&lang=js"
export * from "./PopoverRecebimentoPendente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports